import getEnvironment from '../helpers/getEnvironment';
import localConfig from './config/config.local';
import stgConfig from './config/config.stg';
import prodConfig from './config/config.prod';

const getConfig = () => {
	const environment = getEnvironment();

	if (environment === 'local') return localConfig;
	else if (environment === 'stg') return stgConfig;
	else if (environment === 'prod') return prodConfig;

	return localConfig;
};

export default {
	app: {
		activeApiCalls: [],
		booted: false,
		clientApp: 'materials',
		clientEnv: getEnvironment(),
		contacts: {},
		environment: getEnvironment(),
		featureFlags: {},
		isLoggedIn: false,
		metaData: {},
		navigation: {},
		signupCompleted: false,
		toggleHamburgerMenu: false,
		token: null,
	},

	config: getConfig(),
	pages: {},
	articles: {},
	popups: {},
	modal: {
		visible: false,
		windows: [],
	},
	notification: {
		toast: [],
	},
};
